export default "__VITE_ASSET__BYYfrzZ5__"